// Import browser polyfills first to ensure compatibility
import './utils/browserPolyfills';

// LiveKit compatibility shim — registers window.EnxRtc backed by livekit-client.
// Required because the 3 interview screens still call window.EnxRtc.* APIs.
import './utils/livekit-shim';

// Source attribution capture — snapshot UTM/referrer/landing before any SPA
// navigation can clobber them. First-call wins via sessionStorage.
import { captureUtm } from './utils/captureUtm';

import ReactDOM from "react-dom/client";
import App from "./app";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import store from "./redux/store/store";
import { GlobalContextProvider } from "./context";
import { ThemeProvider } from "./context/theme";
import ErrorBoundary from "./components/ErrorBoundary";

captureUtm();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <ThemeProvider>
      <GlobalContextProvider>
        <ReduxProvider store={store}>
          <Router>
            <App />
          </Router>
        </ReduxProvider>
      </GlobalContextProvider>
    </ThemeProvider>
  </ErrorBoundary>
);
